// import gl from '../lib/gallery_lib';
export default class GalleryAlbum {
  constructor(el) {
    this.el = el;
    this.openEdit = this.el.querySelectorAll('.open-edit');
    this.errorTitle = this.el.getAttribute('data-error-title');
    this.errorMaxChars = this.el.getAttribute('data-error-max-chars');
    this.errorAllovedChars = this.el.getAttribute('data-error-alloved-chars');
    this.deleteTitle = this.el.getAttribute('data-delete-title');
    this.deleteMessage = this.el.getAttribute('data-delete-message');
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.openEdit.forEach(item => {
      item.addEventListener('click', () => {
        // Init
        const actionsWrapper = item.previousElementSibling;
        const itemName = item.previousElementSibling.previousElementSibling;
        const itemWrapper = item.parentElement.parentElement;
        const albumID = itemWrapper.getAttribute('data-album-id');
        const albumName = itemWrapper.getAttribute('data-album-name');
        const btnCancel = actionsWrapper.querySelector('.album-cancel');
        const btnSave = actionsWrapper.querySelector('.album-save');
        const btnDelete = actionsWrapper.querySelector('.album-delete');
        const inField = actionsWrapper.querySelector(
          `input[name="album_name[${albumID}]"]`
        );
        const inFieldCurrent = actionsWrapper.querySelector(
          `input[name="album_name_current[${albumID}]"]`
        );
        const inFieldMessage = itemWrapper.querySelector(`#message-${albumID}`);
        // Actions
        btnCancel.addEventListener('click', () => {
          inField.value = inFieldCurrent.value;
          btnDelete.removeAttribute('disabled');
          inFieldMessage.classList.add('hidden');
          this.implaceEdit('hide', item, itemName, actionsWrapper, itemWrapper);
        });
        // Save changes
        btnSave.addEventListener('click', () => {
          btnDelete.removeAttribute('disabled');
          const newNm = inField.value;
          const nameSpan = actionsWrapper.previousElementSibling.querySelector(
            'span'
          );
          const result = this.saveName(albumID, newNm);
          if (result.error === 0) {
            this.implaceEdit(
              'hide',
              item,
              itemName,
              actionsWrapper,
              itemWrapper
            );
            inField.value = newNm;
            inFieldCurrent.value = newNm;
            nameSpan.innerText = newNm;
            inFieldMessage.classList.add('hidden');
          } else {
            inFieldMessage.classList.remove('hidden');
            inFieldMessage.innerHTML = result.message;
          }
        });
        // Display delete confirm message
        btnDelete.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          btnDelete.setAttribute('disabled', 'disabled');
          inFieldMessage.innerHTML = this.deleteMessage.replace(
            /(%s|%d)/g,
            $0 => {
              const index = {
                '%s': albumName,
                '%d': albumID
              };
              return index[$0] !== undefined ? index[$0] : $0;
            }
          );
          inFieldMessage.classList.remove('hidden');
        });
        // Confirm deletion
        $('body').on('click', '.confirm-delete', e => {
          const elm = e.target || e.srcElement;
          if (elm.id === albumID) {
            itemWrapper.style.display = 'none';
            this.deleteAlbum(albumID);
          }
        });
        // Execute
        this.implaceEdit('show', item, itemName, actionsWrapper, itemWrapper);
      });
    });
  }

  saveName(id, name) {
    const result = {
      error: 0
    };
    if (name.length < 3) {
      result.error = 1;
      result.title = this.errorTitle;
      result.message = this.errorMaxChars;
    } else if (!name.match(/^([a-zA-Z0-9öÖüÜäÄß _-]+)$/)) {
      result.error = 2;
      result.title = this.errorTitle;
      result.message = this.errorAllovedChars;
    } else {
      const data = {
        mode: 'renameGalleryAlbum',
        album_id: id,
        album_name: name
      };
      $.ajax({
        url: '/ajax.php',
        method: 'POST',
        data,
        success: response => {
          if (response.error !== undefined) {
            // eslint-disable-next-line no-alert
            alert('An error is ocurred. Please try again.');
          }
        }
      });
    }
    return result;
  }

  deleteAlbum(id) {
    const data = {
      mode: 'deleteGalleryAlbum',
      album_id: parseInt(id, 10)
    };
    $.ajax({
      url: '/ajax.php',
      method: 'GET',
      data,
      success: response => {
        if (response.error !== undefined) {
          // eslint-disable-next-line no-alert
          alert('An error is ocurred. Please try again.');
        }
      }
    });
  }

  /* eslint-disable no-param-reassign */
  implaceEdit(action, item, itemName, actionsWrapper) {
    switch (action) {
      case 'show':
        // hidde
        item.style.display = 'none';
        itemName.style.display = 'none';
        // show
        actionsWrapper.style.display = '';
        actionsWrapper.querySelector('.edit-name').style.display = '';
        break;
      default:
        // show
        item.style.display = '';
        itemName.style.display = '';
        // hidde
        actionsWrapper.style.display = 'none';
        actionsWrapper.querySelector('.edit-name').style.display = 'none';
        break;
    }
  }
  /* eslint-enable no-param-reassign */
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/gallery_album.js